import { REDUCER_NAME } from './const'
import { createSelector } from 'reselect'
import * as R from 'ramda'
import { sortByProperty } from '../../../util/sort'
import { ROLE_TREATING_PHYSICIAN } from '../../security/state/auth/const'
export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectSalutationList = (state) => {
    return selectOwnState(state).salutationList
}

export const selectLeadStatusList = (state) => {
    return selectOwnState(state).leadStatusList
}

export const selectProcessStateNameList = (state) => {
    return selectOwnState(state).processStateNameList
}

export const selectProcessNameList = (state) => {
    return Object.keys(selectOwnState(state).processStateNameList)
}

export const selectLeadStatusById = (state, statusId) => {
    const statusList = selectLeadStatusList(state)
    return R.find(R.propEq('id', statusId))(statusList)
}

export const selectLeadStatusValueById = (state, statusId) => {
    const status = selectLeadStatusById(state, statusId)
    return status ? status.value : null
}

export const selectSalesOrderTreatmentStatusList = state => {
    return selectOwnState(state).salesOrderTreatmentStatusList
}

export const selectSalesOrderTreatmentStatusById = (state, statusId) => {
    const statusList = selectSalesOrderTreatmentStatusList(state)
    return statusList ? R.find(R.propEq('id', statusId))(statusList) : null
}

export const selectSalesOrderTreatmentStatusValueById = (state, statusId) => {
    const status = selectSalesOrderTreatmentStatusById(state, statusId)
    return status ? status.value : null
}


export const selectSalesOrderStatusList = state => {
    return selectOwnState(state).salesOrderStatusList
}

export const selectSalesOrderStatusById = (state, statusId) => {
    const statusList = selectSalesOrderStatusList(state)
    return statusList ? R.find(R.propEq('id', statusId))(statusList) : null
}

export const selectSalesOrderStatusValueById = (state, statusId) => {
    const status = selectSalesOrderStatusById(state, statusId)
    return status ? status.value : null
}

export const selectUser = (state) => {
    return selectOwnState(state).user
}

export const selectUserViewPreferences = (state) => {
    const { viewPreferences } = selectUser(state)
    return viewPreferences || {}
}


export const selectUserId = (state) => {
    const { id } = selectUser(state)
    return id
}


export const selectUserList = (state) => {
    return selectOwnState(state).userList
}

export const selectTreatingPhysicianList = state => {
    const userList = selectUserList(state)
    return userList.filter(({ roleList }) => {
        return roleList.indexOf(ROLE_TREATING_PHYSICIAN) !== -1
    })
}

export const selectUserWithRoleList = (state, requiredRoleList) => {
    const userList = selectUserList(state)
    return userList.filter(({ roleList }) => {
        for (let index = 0; index < requiredRoleList.length; index++) {
            const requiredRole = requiredRoleList[index]
            if (roleList.indexOf(requiredRole) !== -1) {
                return true
            }
        }
        return false
    })
}


export const selectUserById = (state, userId) => {
    const userList = selectUserList(state) || []
    return R.find(R.propEq('id', userId))(userList)
}


const filterRoleList = (roleList) => {
    const filteredList = roleList.filter(role => {
        return role !== 'reporting' && role !== 'employee' && role !== 'employee.store' && role !== 'employee.office' && role !== 'processAdmin' && role !== 'task_admin' && role !== 'partner'
    })
    const renamedRoleList = filteredList.map(role => {
        return role.replace(/_/g, ' ')
    })
    return renamedRoleList.join(',')
}

export const selectUserDisplayNameById = (state, userId) => {
    const user = selectUserById(state, userId)
    if (!user) {
        return ''
    }
    if (user.externalUserId) {
        return user.firstName + ' ' + user.lastName + ' (External)'
    }
    if (user.firstName && user.lastName) {
        return user.firstName + ' ' + user.lastName
    }
    // externals only see roles
    return filterRoleList(user.roleList)
}

export const selectEmployeeList = (state) => {
    return selectOwnState(state).employeeList
}

export const selectEmployeeById = (state, employeeId) => {
    const employeeList = selectEmployeeList(state) || []
    return R.find(R.propEq('id', employeeId))(employeeList)
}


export const selectEmployeeNameById = (state, employeeId) => {
    const employee = selectEmployeeById(state, employeeId)
    return employee ? employee.firstName : null
}

export const selectTreatmentRateDefault = state => {
    return selectOwnState(state).treatmentRateDefault
}

export const selectTreatmentPriceDefault = state => {
    return selectOwnState(state).treatmentPriceDefault
}

export const selectPartnerList = state => {
    const partnerList = selectOwnState(state).partnerList
    if (!partnerList) {
        return []
    }
    sortByProperty(partnerList, 'displayName')
    return partnerList
}


export const selectPartnerById = (state, partnerId) => {
    const partnerList = selectPartnerList(state)
    return partnerList ? R.find(R.propEq('id', partnerId))(partnerList) : null
}

export const selectPartnerDisplayNameById = (state, partnerId) => {
    const partner = selectPartnerById(state, partnerId)
    return partner ? partner.displayName : ''
}

export const selectPartnerTechnicalNameById = (state, partnerId) => {
    const partner = selectPartnerById(state, partnerId)
    return partner ? partner.technicalName : ''
}

export const selectPhysicianList = createSelector([selectPartnerList], (partnerList) => {
    if (partnerList) {
        return partnerList.filter((partner) => {
            return partner.isPhysician
        })
    } else {
        return []
    }
})

export const selectSupplierDisplayNameWhiteList = state => {
    const supplierDisplayNameWhiteList = selectOwnState(state).supplierDisplayNameWhiteList
    if (!supplierDisplayNameWhiteList) {
        return []
    }
    return supplierDisplayNameWhiteList
}

export const selectSupplierDisplayNameDefault = state => {
    const supplierDisplayNameDefault = selectOwnState(state).supplierDisplayNameDefault
    if (!supplierDisplayNameDefault) {
        return 'SunshineSmile'
    }
    return supplierDisplayNameDefault
}

export const selectSupplierDefaultId = state => {
    const supplierList = selectSupplierList(state)
    const supplierDisplayNameDefault = selectSupplierDisplayNameDefault(state)
    const defaultSupplier = supplierList.filter((item) => {
        return item.displayName === supplierDisplayNameDefault
    }).pop()
    if (!defaultSupplier) {
        return null
    }
    return defaultSupplier.id
}
/**
 * Only SunshineSmile and HAT Group are allowed to be saved as supplier
 * @link https://sunshinesmile.atlassian.net/browse/ENG-4150
*/
export const selectSupplierList = createSelector([selectPartnerList, selectSupplierDisplayNameWhiteList], (partnerList, supplierDisplayNameWhiteList) => {
    if (partnerList) {
        return partnerList.filter((partner) => {
            return (partner.isSupplier && supplierDisplayNameWhiteList.includes(partner.displayName))
        })
    } else {
        return []
    }
})

export const selectTreatmentPlanerList = createSelector([selectPartnerList], (partnerList) => {
    if (partnerList) {
        return partnerList.filter((partner) => {
            return partner.isTreatmentPlaner
        })
    } else {
        return []
    }
})

export const selectRoleTaskMapping = state => {
    return selectOwnState(state).roleTaskMapping
}

export const selectCommonConfiguration = state => {
    return selectOwnState(state).common
}

export const selectBackendUrl = state => {
    const commonConfig = selectCommonConfiguration(state)
    return commonConfig ? commonConfig.backendUrl : ''
}

export const selectFrontendUrl = state => {
    const commonConfig = selectCommonConfiguration(state)
    return commonConfig ? commonConfig.frontendUrl : ''
}

export const selectDeviceList = state => {
    return selectOwnState(state).sipGateDeviceList
}

export const selectStoreList = state => {
    return selectOwnState(state).storeList
}

export const selectStoreByTechnicalName = (state, storeTechnicalName) => {
    const storeList = selectStoreList(state)
    for (let index = 0; index < storeList.length; index++) {
        const store = storeList[index]
        if (store.technicalName === storeTechnicalName) {
            return store
        }
    }
    return null
}

export const isIPRProviderStore = (state, storeTechnicalName) => {
    const store = selectStoreByTechnicalName(state, storeTechnicalName)
    return store ? store.iprProvider : false
}

export const isAttachmentProviderStore = (state, storeTechnicalName) => {
    const store = selectStoreByTechnicalName(state, storeTechnicalName)
    return store ? store.attachmentAvailable : false
}



// WEBPACK FOOTER //
// ./src/modules/globals/state/selector.js